import { HTMLAttributes } from "react"
import { Anchor } from "@/app/components/anchor"

export interface IExpenseCard extends HTMLAttributes<HTMLElement> {
  category: string
  pricePerMile: string
  description: string
  examples: string
  title: string
  // One-line marketplace cost-per-mile trend, shown under the price when the
  // category has live trend data (boats today). Omitted otherwise.
  trendNote?: string
  // tools.json calculator id for this category (boats, cars today). When set,
  // the card links to the internal /tools/{id} calculator page. Omitted for
  // categories with no calculator.
  calculatorToolId?: string
}

export default function ExpenseCard({
  category,
  pricePerMile,
  description,
  examples,
  title,
  trendNote,
  calculatorToolId,
}: IExpenseCard) {
  return (
    <section className="p-6 sm:p-11 rounded-lg bg-white shadow-lg">
      <h3 className="font-semibold text-2xl text-center mb-4">{title}</h3>
      <p className="text-4xl text-center mb-2">
        <span className="font-bold">{pricePerMile}</span>
        <span className="font-light">/mi.</span>
      </p>
      {trendNote && (
        <p className="text-sm text-center text-gray7 mb-6">{trendNote}</p>
      )}
      <p className={trendNote ? "mb-5" : "mt-6 mb-5"}>{description}</p>
      <p className="font-semibold mb-2">{category} include:</p>
      <p className="mb-0">{examples}</p>
      {calculatorToolId && (
        <p className="mt-5 mb-0">
          <Anchor
            href={`/tools/${calculatorToolId}`}
            className="text-blue7 font-semibold underline"
          >
            Estimate your {category.toLowerCase()} shipping cost
          </Anchor>
        </p>
      )}
    </section>
  )
}
